import { get } from "@sal/webrequest-web";
import { assertApiSuccess } from "code/apiError";
import { Account } from "models/Account";
import { useMemo } from "react";
import useSWR from "swr";

const fetcher = async (url: string) => assertApiSuccess(await get(url), "Failed to load accounts.");

export const ACCOUNTS_KEY = "api/Accounts";

export function useGetAccounts() {
	const { data, isLoading, error, mutate } = useSWR(ACCOUNTS_KEY, fetcher, {
		revalidateIfStale: false,
		revalidateOnFocus: false,
		revalidateOnReconnect: false
	});

	const accounts = useMemo(() => (data as Account[]) ?? null, [data]);

	return useMemo(
		() => ({
			accounts,
			isLoading,
			error,
			mutateAccounts: mutate
		}),
		[accounts, isLoading, error, mutate]
	);
}
